const getEnvSource = () => {
    if (typeof window !== 'undefined' && window.__ENV__) {
        return window.__ENV__;
    }
    return process.env;
};

const env = (envName, { optional } = {}) => {
    const value = getEnvSource()?.[envName];
    if (value === undefined && !optional) {
        console.warn(`⚠️ Env variable "${envName}" is not defined`);
    }
    return value;
};


export default env; 